/* eslint-disable no-unexpected-multiline */
import React from 'react'
import {Icon} from '@lazarusai/forms-ui-components'
import {connect} from 'react-redux'
import {storePayload} from '../actions/storePayload'
import SubSection from './SubSection'
import '../styles/SectionSelect.css'

function SectionSelect(props) {
  function onClickSection(sectionIndex, name) {
    const selectedSubSectionName =
      Object.keys(props.prompt1Response[name])
          [props.selectedSubSectionIndex]
    props.storePayload({
      selectedSectionIndex: sectionIndex,
      selectedSectionName: name,
      selectedSubSectionIndex: 0,
      selectedSubSectionName: selectedSubSectionName,
      isSubSectionReadyForReview: false,
      isSectionReadyForReview: false,
      isResourcesPage: false,
      isReview: false,
      isSkip: false,
      typeFormStep: 'typeform',
    })
  }

  function onClickHome() {
    props.storePayload({
      step: 'section-select',
    })
  }

  const sections = Object.keys(props.prompt1Response)

  return (
    <div
      className='section-select'
      onClick={() => {
        if (props.isChatShowing) {
          props.storePayload({
            isChatShowing: false,
          })
        }
      }}
    >
      <div
        id='home-btn'
        onClick={onClickHome}
      >
        <Icon
          icon='home-outline'
          width='24px'
          height='24px'
        />
      </div>
      <div className='section-select-interior'>
        {sections.map((section, i) => {
          const sectionData = props.prompt1Response[sections[i]]
          const total = Object.keys(sectionData).length
          let completed = 0
          Object.keys(sectionData).forEach((subSectionName, j) => {
            const subSection = sectionData[subSectionName]
            // const isSubSectionComplete =
            //   Object.keys(subSection).every((id) => {
            //     const question = subSection[id]
            //     return question['Answer']
            //   })
            const isSubSectionComplete =
              subSection['Response'] ? true : false
            if (isSubSectionComplete) {
              completed++
            }
          })
          const status = completed === total ? 'Complete' : 'Incomplete'
          return (
            <div
              key={`${section} ${i}`}
              className={
                `
                  section-choice
                  ${props.selectedSectionIndex === i ? 'selected' : ''}
                `
              }
            >
              <SubSection
                number={i + 1}
                title={sections[i]}
                completed={completed}
                total={total}
                status={status}
                key={'section-' + i}
                index={i}
                onClick={() => onClickSection(i, sections[i])}
              />
            </div>
          )
        })}
      </div>
    </div>
  )
}

const mapStateToProps = (state) => ({
  theme: state.userReducer.theme,
  selectedSectionIndex: state.userReducer.selectedSectionIndex,
  selectedSubSectionIndex: state.userReducer.selectedSubSectionIndex,
  prompt1Response: state.userReducer.prompt1Response,
  isChatShowing: state.userReducer.isChatShowing,
})

export default connect(
    mapStateToProps,
    {storePayload},
)(SectionSelect)


